import { SerialSettings } from '../models/serialSettings'

export interface SerialSettingsStateType {
  serialSettings: SerialSettings[]
  serialSetting: SerialSettings | null
}

const SerialSettingsState: () => SerialSettingsStateType = () => ({
  serialSettings: [],
  serialSetting: null,
})

export default SerialSettingsState
